var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n    "+_vm._s(_vm._f("secondsToDateMonthDay")(_vm.data.lines.data[0].period.start))+" - "+_vm._s(_vm._f("secondsToDateMonthDay")(_vm.data.lines.data[0].period.end))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }